export const BODEGA = {
    codigo: "11001000",
    empresa: "TRIADA GLOBAL S.A.S",
    nombre: "Daniela",
    apellido: "Ramirez",
    correo: "contactanos.amevi@gmail.com",
    celular: "3224510644",
    direccion: "carrera 53 #123-34 ",
    adicional: "apto 505 edificio biela",
    calle: "Carrera 53",
    referencia: "N/A",
    ciudad: "Bogota",
    cc: "901917279-2",
    departamento: "Cundinamarca"
}

export const NOMBREPEDIDO = 'Pedido Nariño Souvenirs'

export const PESODEFOULT = 500
export const ALTODEFOULT = 25
export const LARGODEFAULT = 20
export const FONDODEFAULT = 10